'use strict';

export default function($stateProvider) {
  'ngInject';

  $stateProvider
    .state('tvs_emerald_benchmark', {
      url: '/tvs_emerald_benchmark',
      template: '<tvsemeraldbenchmarktab></tvsemeraldbenchmarktab>',
      authenticate: 'admin'
    });
}
